import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id/index.ts';
import { Media } from '../../../../../theme/Media.js';
import { Select } from '../../../Select/index.js';
import { isDefinedDateRange } from '../../helpers.js';
import { PresetItem } from './PresetItem.js';
import { Header, MobileHeader, PresetsWrapper } from './styled.js';
export const RangePresets = memo(function RangePresets({ presets, startDate, endDate, onChange, translations }) {
    const title = translations.period;
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectOptions = useMemo(() => presets.map(({ title, dateRange }) => ({
        label: title,
        value: dateRange,
    })), [presets]);
    const selectedValue = useMemo(() => {
        const activePreset = presets.find(({ isActive, dateRange }) => isActive([startDate, endDate], dateRange));
        return activePreset ? { label: activePreset.title, value: activePreset.dateRange } : undefined;
    }, [endDate, presets, startDate]);
    const handleSelectChange = useCallbackRef((option) => {
        if (option?.value && isDefinedDateRange(option.value)) {
            onChange(option.value);
        }
    });
    const createRangePresetClickHandler = useCallbackRef((dateRange) => () => {
        if (isDefinedDateRange(dateRange)) {
            onChange(dateRange);
        }
    });
    return (_jsx("div", { children: isMobile ? (_jsxs("div", { children: [_jsx(MobileHeader, { children: title }), _jsx(Select, { options: selectOptions, value: selectedValue, onChange: handleSelectChange })] })) : (_jsxs(_Fragment, { children: [_jsx(Header, { children: title }), _jsx(PresetsWrapper, { children: presets.map(({ isActive, title, dateRange, dataTestId }) => {
                        const isActivePreset = isActive([startDate, endDate], dateRange);
                        return (_jsx(PresetItem, { title: title, isActive: isActivePreset, onClick: createRangePresetClickHandler(dateRange), dataTestId: getDataTestId(dataTestId), isCustom: !dateRange[0] && !dateRange[1], range: true }, title));
                    }) })] })) }));
});
